module.exports = __webpack_public_path__ + "static/media/mountain-illustration-no-treeline.494ea250.svg";